import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const styles = {
  para: {
    fontSize: 16
  },
  root: {
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap"
  },
  card: {
    minWidth: 275,
    maxWidth: 345,
    flex: 1,
    margin: 5
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  }
};

function SimpleCard(props) {
  const { classes } = props;

  return (
    <div>
      <Card>
        <CardContent>
          <div style={{ textAlign: "center" }}>
            <img
              style={{ borderRadius: "8px" }}
              src="./fablabzero.png"
              alt="logo"
              width="100%"
            />
          </div>
          <Typography variant="h5" align="center">
            Manoj Sahukar's Project Journal
          </Typography>
        </CardContent>
      </Card>
      <br />
      <div className={classes.root}>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6" component="h2">
              About
            </Typography>
            <Typography className={classes.para} paragraph>
              Inquisitive, Skeptic, Transhumanist, Stoic, Freethinker,
              Deontological, Ambivert and Neoteric etc. are the words I use to
              describe myself more or less. I have B.Tech. in Mechanical
              Engineering and M.Tech in 'Entrepreneurship {"&"} Innovations'.
              Before Fab Academy, my last job role was 'Business Developer' at
              Elegate.org, Cairo (Egypt). Prior to that I worked in
              Neuromarketing related technologies for my Master's thesis.
            </Typography>
          </CardContent>
          <CardActions>
            {/* <Button
              target="_blank"
              href="https://manojsahukar.xyz"
              size="small"
            >
              Read More
            </Button> */}
          </CardActions>
        </Card>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6">My Lab</Typography>
            <Typography className={classes.para} paragraph>
              Vigyan Ashram is a center of Indian Institute of Education (IIE)
              Pune established by Dr.S.S. Kalbag in 1983. It's a modern version
              of old Gurukula systems of 'simple living and high thinking'.
              Dr.Neil Greshenfeld, (Director, Center of Bits and atoms, MIT
              (USA)) who created the Fab Lab, described Vigyan Ashram as ‘Fab
              Lab Zero’. VA-Fab lab was established through the interaction
              between Dr.Kalbag and Dr. Dr.Neil Greshenfeld in 2002. VA made
              slow and steady progress to master the use of Fab Lab to solve
              rural problems.
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              target="_blank"
              href="http://vigyanashram.com/"
              size="small"
            >
              Read More
            </Button>
          </CardActions>
        </Card>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6">Project</Typography>
            <Typography className={classes.para} paragraph>
              Stink-o-Meter
              <br />
              It is an e-nose, specifically designed and trained for detecting
              bad odors. It is an array of chemical gas sensors housed in a
              device that uses pattern recognition to recognize, identify, and
              compare odors. The objective is to monitor and map all regions of
              India with this lowcost opensource device and create open stink
              data. If that sounds too bold, a practical use case is management
              of public garbage bins and toilets in India.
            </Typography>
          </CardContent>
          <CardActions>
            {/* <Button onClick={this.props.project} size="small">
              Read More
            </Button> */}
          </CardActions>
        </Card>
      </div>
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
